import configureStore from './configureStore'


let store = null;

const getStore = () => {
    if (store) return store
    else return store = configureStore()
}

export default getStore


// WEBPACK FOOTER //
// ./src/store/index.js